<mat-dialog-content class="gdpr-content">
  <div [innerHTML]="'dialogs.gdpr.content' | translate"></div>
</mat-dialog-content>
